import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from 'src/environments/environment';

import { CoreModule } from './core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { localeFactory } from './core/factories';
import { LocaleService } from './core/services/locale';
import { LocaleConfigService } from './core/services/locale/locale.config.service';

@NgModule({
    declarations: [AppComponent],
    imports: [AppRoutingModule, BrowserModule, BrowserAnimationsModule, CoreModule.forRoot(environment.dashboardCoreConfig)],
    providers: [
        LocaleConfigService,
        {
            provide: LOCALE_ID,
            deps: [LocaleConfigService],
            useFactory: ($locale: LocaleConfigService) => $locale.get()
        },
        {
            provide: LocaleService,
            useFactory: localeFactory,
            deps: [ LOCALE_ID ]
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
